import { FT5_EVENT_TRACKING } from '../../../constants';
import { DataContainer } from '@otto-ec/tracking-bct';
import { emitTrackingEvent } from '../../../_common/client/tracking/emit-tracking-event';
import { BCT_TRACKING_SUBMIT_ACTION } from '../../../_common/client/bct-event-topics';
import { getProductFeaturesForNonPdpPage } from '../../../_common/client/tracking/get-product-features-for-non-pdp-page';

export function registerEventTracking(variationData: { productId: string; variationId: string; moin: string }) {
    o_global.eventQBus.on(FT5_EVENT_TRACKING, (trackingData: DataContainer) => {
        emitTrackingEvent(BCT_TRACKING_SUBMIT_ACTION, trackingData, {
            name: 'click',
            features: getProductFeaturesForNonPdpPage(variationData),
        });
    });
}
